<template>
    <div>
        <div class="magicCubeConfig">
<!--            <span>魔方密度</span>-->
            <div class="radio">
                <el-radio-group v-model="data.modeNumber" @input="clearDataList">
                    <el-radio v-for="(item,index) in modeData" :key="index" :label="item.modeType">{{item.modeText}}</el-radio>
                </el-radio-group>
            </div>
        </div>
        <div class="magicCubeContent">
            <ul v-for="x in data.modeNumber">
                <li v-for="y in data.modeNumber" :style="'width:' + sideLength + 'px; height:' + sideLength + 'px;'" :class="{'selecting' : onSelecting(x,y)}" @mousemove="onMousemove(x,y)" @click="onClick(x,y)">
                    <i class="el-icon-plus" v-if="!onSelecting(x,y)"></i>
                </li>
            </ul>
            <div class="customizeBox" v-for="(item,index) in data.boxList" :key="index" :class="{'active': activeId === item.id}" @click="onClickBox(item)"
                 :style="'width:' + item.widthNumber * sideLength + 'px; height:' + item.heightNumber * sideLength + 'px; top:' + item.top * sideLength + 'px; left:' + item.left * sideLength + 'px'">
                <img v-if="item.imageUrl" :src="item.imageUrl">
                <span v-else>{{`${item.widthNumber * sideLength * 2}x${item.heightNumber * sideLength * 2}`}}</span>
                <div class="deleteBox" v-if="activeId === item.id" @click.stop="onDeleteBox(item)">
                    <i class="el-icon-close"/>
                </div>
            </div>
        </div>
        <div class="imageBox" v-if="activeId">
            <div class='item-left'>
                <uploadImage :imageUrl="data.boxList.find((item)=> item.id === activeId).imageUrl" @deleteUrl="deleteLogoUrl(activeId)" @updateUrl="updateLogoUrl($event,activeId)"/>
            </div>
            <div class='item-right'>
                <el-input v-model='data.boxList.find((item)=> item.id === activeId).info[0].value' :max='data.boxList.find((item)=> item.id === activeId).info[0].max' placeholder="请输入标题" size='small'></el-input>
                <pathselect :value="data.boxList.find((item)=> item.id === activeId).info[1].value" :disabled="false"  @change="changePathSelect($event,data.boxList.find((item)=> item.id === activeId).info[1])"></pathselect>
            </div>
        </div>
    </div>
</template>

<script>
import uploadImage from '@/components/decoration/common/uploadImage.vue';
import Pathselect from '@/components/pathselect/pathselect.vue';
export default {
    components: {
        Pathselect,
        uploadImage
    },
    props:{
        data:{
            type: Object,
            default: null,
        }
    },
    data(){
        return{
            modeData:[
                // modeType 长款模式
                // sideLength 边长 单位像素
                { modeType: 4, modeText: "4x4", sideLength: 96 },
                { modeType: 5, modeText: "5x5", sideLength: 77 },
                { modeType: 6, modeText: "6x6", sideLength: 64 },
                { modeType: 7, modeText: "7x7", sideLength: 55 }
            ],
            oneCoordinate:[], // 第一次点击记录位置
            twoCoordinate:[], // 第二次点击记录位置
            activeId: "", // 当前选中的格子
        }
    },
    computed:{
        // 边长
        sideLength(){
            return  this.modeData.find(item=>{
                return item.modeType === this.data.modeNumber
            }).sideLength
        }
    },
    methods: {

        // 鼠标移动
        onMousemove(x, y){
            this.twoCoordinate = [x,y]
        },

        // 预选盒子显示
        onSelecting(x,y){

            if(this.oneCoordinate.length === 0 || this.twoCoordinate.length === 0){
                return false
            }

            let oneX = this.oneCoordinate[0]
            let oneY = this.oneCoordinate[1]
            let twoX = this.twoCoordinate[0]
            let twoY = this.twoCoordinate[1]
            let minX,minY,maxX,maxY = 0

            if(oneX > twoX){
                maxX = oneX
                minX = twoX
            } else {
                maxX = twoX
                minX = oneX
            }
            if(oneY > twoY){
                maxY = oneY
                minY = twoY
            } else {
                maxY = twoY
                minY = oneY
            }

            if(minX > x || maxX < x) return false;
            if(minY > y || maxY < y) return false;
            return true
        },

        // 鼠标点击
        onClick(x, y){
            // 点击第二次设置盒子
            if(this.oneCoordinate.length > 0 && this.oneCoordinate.length > 0){
                this.computeBox();
                return;
            }

            // 设置第一个坐标
            if(this.oneCoordinate.length === 0){
                this.oneCoordinate = [x,y]
            }
        },

        // 计算盒子大小位置
        computeBox(){
            // 盒子的长宽积数计算
            let oneX = this.oneCoordinate[1]
            let oneY = this.oneCoordinate[0]
            let twoX = this.twoCoordinate[1]
            let twoY = this.twoCoordinate[0]
            let widthNumber,heightNumber,minX,minY,maxX,maxY = 0

            /**
             * 这俩个if是为了找出x,y最小的那个值， x,y都取最小的值就是选择盒子左上角盒子的坐标
             * 宽 = x最大坐标 - x最小坐标 + 1
             * 高 = y最大坐标 - y最小坐标 + 1
             */
            if(oneX > twoX){
                widthNumber = oneX - twoX + 1
                minX = twoX
                maxX = oneX
            } else {
                widthNumber = twoX - oneX + 1
                minX = oneX
                maxX = twoX
            }
            if(oneY > twoY){
                heightNumber = oneY - twoY + 1
                minY = twoY
                maxY = oneY
            } else {
                heightNumber = twoY - oneY + 1
                minY = oneY
                maxY = twoY
            }

            // 定位的位置积数计算
            let top = (minY - 1);
            let left = (minX - 1);

            // 生产id
            let id = new Date().getTime()

            // 盒子数据列表
            this.data.boxList.push({
                id, // id
                widthNumber, // 宽占几个格子
                heightNumber, // 长占几个格子
                top, // 定位位置
                left, // 定位位置
                start: `${minX},${minY}`,
                end: `${maxX},${maxY}`,
                imageUrl: "",
                info: [
                    {
                        title: '标题',
                        value: '链接标题',
                        tips: '选填，不超过4个字',
                        max: 4
                    },
                    {
                        title: '链接',
                        value: '/',
                        tips: '请输入链接',
                        max: 100
                    }
                ]
            })

            // 将当前新增盒子设置为当前选中的盒子
            this.activeId = id;

            // 重置当前选择器
            this.oneCoordinate = []
            this.twoCoordinate = []
        },

        // 选中已添加的盒子
        onClickBox(item){
            this.activeId = item.id;
        },

        // 删除选中的盒子
        onDeleteBox(obj){
            this.oneCoordinate = [];
            this.twoCoordinate = [];
            this.activeId = "";
            this.data.boxList = this.data.boxList.filter(item => item.id !== obj.id);
        },

        // 清楚当前已存在的全部盒子
        clearDataList(){
            this.data.boxList = [];
            this.activeId = "";
        },

        // 删除图片
        deleteLogoUrl(activeId){
            this.data.boxList.find(item=>item.id === activeId).imageUrl = "";
        },

        // 设置图片
        updateLogoUrl(url, activeId){
            this.data.boxList.find(item=>item.id === activeId).imageUrl = url;
        },

        changePathSelect(e,obj){
            obj.value = e;
        }
    }
}
</script>

<style scoped lang="scss">
    .magicCubeConfig{
        display: flex;
        flex-direction: column;

        .radio{
            margin: 10px;
        }
    }

    .magicCubeContent{
        position: relative;
        width: 100%;
        margin-top: 10px;

        .customizeBox{
            position: absolute;
            background: #fff;
            border: 1px solid #e5e5e5;
            color: #636669;
            font-size: 12px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            img{
                width: 100%;
                height: 100%;
            }

            .deleteBox{
                position: absolute;
                top: -10px;
                right: -10px;
                width: 15px;
                height: 15px;
                z-index: 1;
                border-radius: 50%;
                background: #b8b9bd;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: center;
            }
        }

        .active{
            background: #d5e8fc;
            border: 1px solid #0256ff;
            color: #0256ff;
        }

        ul{
            display: flex;

            li{
                flex: 1;
                border: 1px solid #e5e5e5;
                background-color: #f4f6f8;
                color: #939799;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .selecting{
                background: #e8f7fd;
            }
        }
    }

    .imageBox{
        width: 100%;
        height: 80px;
        margin-top: 10px;
        padding-top: 10px;
        border-top: 1px solid #eee;
        display: flex;
        flex-direction: row;
        .item-left{
            position: relative;
            width: 110px;
            display: flex;
            flex-direction: row;
            align-items: center;
            .delete-btn{
                position: absolute;
                top: -15px;
                right: 1px;
                font-size: 24px;
                z-index: 1;
            }
            .flag{
                width: 30px;
                height: 100%;
                display: flex;
                align-items: center;
                justify-content: center;
                >i{
                    transform: rotate(90deg);
                    color: #dddddd;
                    cursor: move;
                }
            }
        }
        .item-right{
            flex: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-around;
            ::v-deep .el-input {
                width: 275px;
            }
        }
    }
</style>